/**
 * RESPONSIBILITY: the Children's page events band.
 *
 * The events arrive already filtered to this page's tag — the page decides which slice,
 * this draws it.
 */
import { idOf } from '@framework/core';
import type { ChildrenEventsSection, EventRow } from '@app/sections';
import { EventCard } from '../events/EventCard';
import { Page, hrefFor } from '../commons/pages';

export function ChildrenEvents(
  { c, events }: { c: ChildrenEventsSection; events: EventRow[] },
) {
  return (
    <section className="band band-tint">
      <div className="wrap">
        <div className="band-head">
          <h2>{c.eventsHeading}</h2>
          <a className="btn btn-ghost" href={c.allEventsHref || hrefFor(Page.Events)}>
            {c.allEventsLabel}
          </a>
        </div>
        <div className="grid grid-3">
          {events.map((e) => <EventCard key={idOf(e)} e={e} />)}
        </div>
      </div>
    </section>
  );
}
